import React from "react";
import { Box, Typography, Paper, Stack, Divider } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
const SignupFunnelCard = ({
  title,
  mainValue,
  mainColor,
  percentage,
  avgCompletion,
  successRate,
  totalSignups,
  completed,
  conversionActive,
  retentionRate,
  avgTimeFirstAction,
  abandoned
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid #eee",
        flex: 1,
        minWidth: 300,
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontWeight={500} sx={{fontSize:'16px', color:'#3E3E3E',}}>
          {title}
        </Typography>
        {/* <Box
          sx={{
            border: "1px solid #ddd",
            px: 1,
            py: 0.2,
            borderRadius: "8px",
            fontSize: "0.8rem",
            color: "#444",
          }}
        >
          {percentage}%
        </Box> */}
      </Stack>

      {/* Main number */}
      <Typography 
        fontWeight={500}
        sx={{ color: mainColor, mt: 1, fontSize:'24px' }}
      >
        {mainValue.toLocaleString()}
      </Typography>
      {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 1, color:'#757575', }}>
        Avg. completion: {avgCompletion}
      </Typography> */}

      {/* Success rate */}
      <Typography variant="body2" sx={{ mb: 2, color:'#3C4043', fontSize:'14px', display:'flex', justifyContent:'space-between', }}>
        success rate <strong>{successRate}%</strong>
      </Typography>

      {/* Total vs Completed */}
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          bgcolor: "#f8f8f8",
          p: 1,
          borderRadius: 1,
          mb: 2,
        }}
      >
        <Typography variant="body1" fontWeight={500} color="#2E80DB" sx={{textAlign:'center', fontSize:'24px'}}>
          {totalSignups}
          <Typography sx={{fontSize:'14px', color:'#757575', display:'block',}}>Total Signups</Typography> 
        </Typography>
        <Typography variant="body1" fontWeight={500} color="#02BC7D" sx={{textAlign:'center',fontSize:'24px'}}>
          {completed}
          <Typography sx={{fontSize:'14px', color:'#757575', display:'block',}}>Completed</Typography>
        </Typography>
      </Stack>

      {/* Stats */}
      <Typography variant="body2" sx={{fontSize:'14px', py:0.3, color:'#3C4043', display:'flex', justifyContent:'space-between', alignItems:'center',}}>
        Conversion Rate <strong>{conversionActive}%</strong>
      </Typography>
      <Typography variant="body2" sx={{fontSize:'14px', py:0.3, color:'#3C4043', display:'flex', justifyContent:'space-between', alignItems:'center',}}>
        Retention Rate <strong>{retentionRate}%</strong>
      </Typography>
      {/* <Typography variant="body2" sx={{fontSize:'14px', py:0.3, color:'#3C4043', display:'flex', justifyContent:'space-between', alignItems:'center',}}>
        Avg. Time to First Action <strong>{avgTimeFirstAction}</strong>
      </Typography> */}

      {/* Abandoned */}
      <Typography
        variant="body2"
        sx={{  fontSize: "0.85rem", color:'#979797', display:'flex', alignItems:'center', gap:0.5, mt:1.5, }}
      >
        <FiberManualRecordIcon sx={{fontSize:'12px', color: "#EA4335",}} /> Abandoned: {abandoned}
      </Typography>
    </Paper>
  );
};

export default SignupFunnelCard;
